import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChatService, UserService } from '@app/core';
import { IChat } from '@app/core/models/chat';
import { CommonService } from '@app/core/services/common.service';
import { environment } from '@environments/environment';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-chat',
  templateUrl: './user-chat.component.html',
  styleUrls: ['./user-chat.component.scss'],
})
export class UserChatComponent implements OnInit {
  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  userId: any = '';
  chatData: any = [];
  filter = {
    limit: 15,
    skip: this.chatData.length || 0,
    page: false,
  };
  constructor(
    private _activated: ActivatedRoute,
    private _chat: ChatService,
    private _user: UserService,
    private _common: CommonService
  ) { }

  ngOnInit(): void {
    this._activated.parent?.paramMap.subscribe((params) => {
      let slug: any = params.get('slug');
      if (!slug) {
        this._user.authUser
          .pipe(takeUntil(this.destroyed$))
          .subscribe((user) => {
            if (user && user.id) {
              this.userId = user.id;
              this.getChatData(this.userId);
            }
          });
      } else {
        let id = slug?.split('-').pop();
        if (this._common.isBrowser) {
          this.userId = atob(id);
        } else {
          this.userId = Buffer.from(id, 'base64').toString(); // Ta-da
        }
        this.getChatData(this.userId);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  async getChatData(id: number) {
    let param = new HttpParams().set('limit', this.filter.limit).set('skip', 0);
    let res = await this._chat.getUserMessages(id, param);
    this.chatData = res.data;
    this.filter.page = this.chatData.length == this.filter.limit;
  }

  async loadMore(element: any = null) {
    if (element) {
      element.innerHTML =
        '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
    }
    this.filter.skip = this.chatData.length;
    let param = new HttpParams()
      .set('limit', this.filter.limit)
      .set('skip', this.filter.skip);
    let res = await this._chat.getUserMessages(this.userId, param);
    this.filter.page = res.data.length == this.filter.limit;
    this.chatData.push(...(res.data as IChat[]));
    if (element) {
      element.innerHTML = 'Load More';
    }
  }

  /**
   * function which is use for send message
   * @param msgobj
   * @returns
   */
  async sendMessage(msgobj: { msg: string }) {
    if (!this._user.isLoggedIn()) return;
    if (!msgobj.msg) return;
    let user: any = this._user.authUser.getValue();
    let room = user.id;
    let obj = {
      user_id: user.id,
      message: msgobj.msg,
      sport: null,
      avatar: environment.assetUrl + '/' + user.user_avatar,
      sport_winnings: user[`total_winnings`],
      sport_rank: user[`kingpin_rank`],
      username: user.name,
      membership: user.membership,
      room: room,
      likes: 0,
      hidden: 0,
      profile_id: parseInt(this.userId),
    };
    this._chat._socket.emit('chat', obj);
    this.getChatData(this.userId);
  }
}
